import type { EnvResponse } from "src/queries/env/env.types";
import { makeQuery } from "src/queries/makeQuery";

const sortEnvs = (rawEnvs: EnvResponse[]) =>
  rawEnvs?.length
    ? [...rawEnvs].sort((a, b) => b.cnt - a.cnt || a.env.localeCompare(b.env))
    : [];

export const useQueryEnvs = makeQuery<EnvResponse[], EnvResponse[]>("/api/envs", {
  select: sortEnvs,
});
